import { dbService } from "../firebaseInstance";
import firebase from "firebase/compat/app";

/**
 * 인증 및 토큰 상태를 체크하는 디버깅 유틸리티
 */
export const checkAuthStatus = async () => {
  console.log("=== AUTH STATUS CHECK ===");
  
  // 1. localStorage 체크
  const accessToken = localStorage.getItem("accessToken");
  const userID = localStorage.getItem("userID");
  const longLivedToken = localStorage.getItem("longLivedToken");
  
  console.log("📦 LocalStorage Status:");
  console.log("- accessToken:", accessToken ? `${accessToken.substring(0, 20)}...` : "MISSING");
  console.log("- userID:", userID || "MISSING");
  console.log("- longLivedToken:", longLivedToken ? "EXISTS" : "MISSING");
  
  // 2. Firebase Auth 상태 체크
  const currentUser = firebase.auth().currentUser;
  console.log("🔥 Firebase Auth User:", currentUser ? currentUser.uid : "NOT LOGGED IN");
  
  // 3. Firestore 권한 체크
  if (userID) {
    try {
      const userRef = dbService.collection("user").doc(userID);
      const userDoc = await userRef.get();
      console.log("✅ Firestore Read Test: SUCCESS");
      console.log("- User document exists:", userDoc.exists);
      if (userDoc.exists) {
        const userData = userDoc.data();
        console.log("- collectionList:", userData.collectionList || []);
        console.log("- collectionList length:", userData.collectionList?.length || 0);
      }
    } catch (error) {
      console.error("❌ Firestore Read Test: FAILED", error.message);
      console.error("- Error code:", error.code);
      console.error("- Full error:", error);
    }
  }
  
  console.log("=== END AUTH CHECK ===");
  
  return {
    hasAccessToken: !!accessToken,
    hasUserID: !!userID,
    hasLongLivedToken: !!longLivedToken,
    firebaseUser: !!currentUser,
    timestamp: new Date().toISOString()
  };
};

/**
 * Firestore 보안 규칙 테스트
 */
export const testFirestorePermissions = async (userID) => {
  console.log("=== FIRESTORE PERMISSIONS TEST ===");
  
  const tests = [
    {
      name: "Read user document",
      test: async () => {
        const doc = await dbService.collection("user").doc(userID).get();
        return doc.exists;
      }
    },
    {
      name: "Read collection document",
      test: async () => {
        // 테스트용 컬렉션 ID (실제로는 존재하지 않을 수 있음)
        const testCollectionId = "test-collection-id";
        try {
          await dbService.collection("collection").doc(testCollectionId).get();
          return true;
        } catch (error) {
          if (error.code === "permission-denied") {
            return false;
          }
          // 문서가 없는 것은 권한 문제가 아님
          return true;
        }
      }
    },
    {
      name: "List collections",
      test: async () => {
        try {
          const snapshot = await dbService.collection("collection")
            .where("userID", "==", userID)
            .limit(1)
            .get();
          return true;
        } catch (error) {
          return false;
        }
      }
    }
  ];
  
  for (const { name, test } of tests) {
    try {
      const result = await test();
      console.log(`✅ ${name}: ${result ? "PASS" : "FAIL"}`);
    } catch (error) {
      console.error(`❌ ${name}: ERROR - ${error.message}`);
    }
  }
  
  console.log("=== END PERMISSIONS TEST ===");
};